// src/pages/Reader.js
import React from "react";
import { motion } from "framer-motion";  // ✅ NEW!

const Reader = () => {
  return (
    <motion.div
      style={styles.container}
      style={{ background: "linear-gradient(135deg, #0d0d0d 30%, #7c3aed 100%)", minHeight: "100vh" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <h1>📖 Reader Page</h1>
      <p>This is where you'll read chapters with full reader experience.</p>
    </motion.div>
  );
};

const styles = {
  container: {
    minHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#0f0f0f",
    color: "#ffffff",
    padding: "2rem",
    textAlign: "center",
  },
};

export default Reader;
